import { render, staticRenderFns } from "./BaseFilterBadge.vue?vue&type=template&id=93a74f4e&scoped=true&"
import script from "./BaseFilterBadge.vue?vue&type=script&lang=js&"
export * from "./BaseFilterBadge.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilterBadge.vue?vue&type=style&index=0&id=93a74f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a74f4e",
  null
  
)

export default component.exports